import React from "react";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer_content">
                <div className="footer_section footer_contact">
                    <h4>
                        <i class="fa-solid fa-envelope-circle-check"></i>{" "}
                        Kontakt
                    </h4>
                    <div className="footer_section_box">
                        <a href="mailto:inzynier.olszynska@gmail.com">
                            <i className="fa-solid fa-envelope"></i>{" "}
                            inzynier.olszynska@gmail.com
                        </a>
                        <a href="tel:+48505042299">
                            <i className="fa-solid fa-phone"></i> +48
                            505-042-299
                        </a>
                    </div>
                </div>

                <div className="footer_divider"></div>

                <div className="footer_section footer_social">
                    <h4>
                        <i class="fa-solid fa-link"></i> Social
                    </h4>
                    <a
                        href="https://www.linkedin.com/in/magdalena-olszyńska-0022409b/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <i className="fa-brands fa-linkedin"></i> LinkedIn
                    </a>
                </div>
            </div>

            <div className="footer_line"></div>

            <div className="footer_bottom">
                <p>
                    © {new Date().getFullYear()} Magdalena Olszyńska | Doradca
                    do spraw aparatury medycznej
                </p>
            </div>
        </footer>
    );
};

export default Footer;
